import { Flex, SubTitle, Switch } from '@teko/ds-mobile';
import { useDistanceTerminalContext } from 'contexts';
import { t } from 'i18n';
import { useGetDistanceTerminal } from '../useGetDistanceTerminal';

export const SwitchGetByGeoLocation = () => {
  const {
    isGetCurrentLocation,
    setIsGetCurrentLocation,
    setIsModeEnterAddress,
  } = useDistanceTerminalContext();
  const { requestLocation } = useGetDistanceTerminal();

  return (
    <Flex align="start" justify="space-between" width="100%">
      <SubTitle level={1}>{t('Bật định vị để tìm siêu thị gần nhất')}</SubTitle>
      <Switch
        checked={isGetCurrentLocation}
        onChange={() => {
          if (isGetCurrentLocation) {
            setIsGetCurrentLocation?.(false);
            setIsModeEnterAddress?.(true);
          } else {
            requestLocation(() => setIsGetCurrentLocation?.(true));
          }
        }}
      />
    </Flex>
  );
};
